<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :toolbar-title="toolbarTitle"
    :persistent="true"
    :can-edit="canEdit"
    :list-title="listTitle"
    :add-button="addButton"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="dialogMaxWidth"
    :dialog-toolbar-title="dialogToolbarTitle + (theObservationType === '1' ? 'observación' : (theObservationType === '2' ? 'incidencia' : 'Felicitación'))"
  >
    <v-list style="max-height: 282px" class="scroll-y" three-line slot="card-text" v-if="items.length > 0">
      <transition-group name="list" tag="span">
        <template v-for="(item, index) in items">
          <v-list-tile ripple avatar :key="(index + 2 * 100)" @click="openMessage(index)">
            <v-list-tile-action>
              <v-icon v-if="parseInt(item.booking_observation_type) === 1" :color="color">chat_bubble</v-icon>
              <v-icon v-else-if="parseInt(item.booking_observation_type) === 2" :color="color">notification_important</v-icon>
              <v-icon v-else-if="parseInt(item.booking_observation_type) === 3" :color="color">thumb_up_alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.booking_observation_title"></v-list-tile-title>
              <v-list-tile-sub-title v-html="'<span class=\'text--primary\'>' + item.booking_observation_user + '</span> &mdash; ' + item.booking_observation_message"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="deleteButton">
              <v-tooltip bottom>
                <v-btn slot="activator" icon flat :color="color" @click="askForConfirmation(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>{{ deleteIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== items.length" :inset="false" :key="(index + 1 * 100)"></v-divider>
        </template>
      </transition-group>
    </v-list>

    <v-layout slot="dialog-card-text" row align-center justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-form ref="form" v-model="valid">
          <v-flex xs12 sm12 md12 lg12>
            <v-text-field
              :label="textFieldLabel"
              single-line
              :disabled="theTitleDisabled"
              required
              :rules="textFieldRules || []"
              v-model="observationTitle"
            ></v-text-field>
            <v-text-field
              v-model="observationMsg"
              color="primary"
              required
              multi-line
              :rows="5"
            >
              <div slot="label">
                Mensaje
              </div>
            </v-text-field>
              <v-btn-toggle class="types" v-model="theObservationType">
                <v-btn flat value="1">
                  Observación
                </v-btn>
                <v-btn flat value="2">
                  Incidencia
                </v-btn>
              </v-btn-toggle>
          </v-flex>
        </v-form>
      </v-flex>
    </v-layout>
    
    <div slot="dialog-card-actions">
      <v-btn
        :color="color"
        flat
        @click.native="$refs.aggregator.dialog = false"
      >
        {{ cancelButton }}
      </v-btn>
      <v-btn
        v-show="valid"
        :color="color"
        flat
        @click.native="addObservation()"
      >
        {{ confirmButton }}
      </v-btn>
    </div>

    <v-dialog slot="extras" v-model="preview" max-width="650">
      <v-card>
        <v-toolbar :color="color" dark>
          <v-icon v-if="parseInt(type) === 1" color="white">chat_bubble</v-icon>
          <v-icon v-else-if="parseInt(type) === 2" color="white">notification_important</v-icon>
          <v-icon v-else-if="parseInt(type) === 3" color="white">thumb_up_alt</v-icon>
          <v-toolbar-title>{{ parseInt(type) === 1 ? 'OBSERVACÍÓN' : 'INCIDENCIA' }}</v-toolbar-title>
        </v-toolbar>
        <v-card-title class="headlines">{{ title }}</v-card-title>
        <v-card-text class="card-texts">
          {{ message }}
        </v-card-text>
        <div class="card-date">{{ date }}</div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="preview = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>

  </vuetify-aggregator-card>
</template>

<script>
  'use strict'

  import moment from 'moment'
  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'

  export default {

    name: 'VuetifyObservationAggregator',

    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm
    },

    props: {
      observations: {
        type: Array,
        default: null,
        required: true
      },
      addButton: {
        type: Boolean,
        default: true,
        required: false
      },
      deleteButton: {
        type: Boolean,
        default: true,
        required: false
      },
      theTitleDisabled: {
        type: Boolean,
        default: false,
        required: false
      },
      canEdit: {
        type: Boolean,
        default: true,
        required: false
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      dialogMaxWidth: {
        type: Number,
        default: 450,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      textFieldLabel: {
        type: String,
        default: 'Phone',
        required: false
      },
      textFieldRules: {
        type: Array,
        default: null,
        required: false
      },
      selectLabel: {
        type: String,
        default: 'Type',
        required: false
      },
      observationTypes: {
        type: Array,
        default: null,
        required: false
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete area',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: 'Estás a punto de eliminar un área de trabajo',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      value: {
        type: Array,
        default: null
      }
    },

    data: () => ({
      items: [],
      titleDisabled: false,
      dialog: false,
      valid: false,
      title: '',
      date: '',
      message: '',
      type: '',
      user: '',
      preview: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [
        {
          text: 'Phone'
        },
        {
          text: 'Mobile'
        },
        {
          text: 'Fax'
        }
      ],
      theObservationType: '1',
      observationType: null,
      observationTitle: null,
      observationMsg: null,
      observationRef: null
    }),

    created () {
      this.items = this.observations
    },

    watch: {
      theTitleDisabled: {
        handler: function (newVal, oldVal) {
          this.titleDisabled = this.theTitleDisabled
        },
        deep: true
      },
      observationTypes: {
        handler: function (newVal, oldVal) {
          this.types = newVal
          this.observationType = this.types[0]
        },
        deep: true
      },

      observations: {
        handler: function (newVal, oldVal) {
          this.items = newVal
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation (index) {
        this.currentIndex = index
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      humanize (date) {
        return 'Enviado por ' + this.user + ' el ' + moment(date).format('DD-MM-YYYY') + ' a las ' + moment(date).format('HH:mm') + 'h.'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deleteObservation()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteObservation () {
        this.$emit('on-delete-observation', this.currentIndex, this.items[this.currentIndex])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openMessage (index) {
        if (!this.showConfirmDialog) {
          this.message = this.items[index].booking_observation_message
          this.user = this.items[index].booking_observation_user
          this.title = this.items[index].booking_observation_title
          this.date = this.humanize(this.items[index].booking_observation_created)
          this.type = this.items[index].booking_observation_type
          this.preview = true
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      closeAggregator () {
        this.$refs.aggregator.dialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openAggregator (type, title, message, ref, dialog, titleDisabled) {
        this.titleDisabled = titleDisabled || false
        this.observationTitle = title || ''
        this.observationRef = ref || ''
        this.theObservationType = type || '1'
        this.observationMsg = message || ''
        this.$refs.aggregator.dialog = !(dialog === false)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addObservation () {
        this.closeAggregator()
        let item = {
          booking_id: 0,
          booking_observation_message: this.observationMsg,
          user_id: 0,
          booking_observation_id: 0,
          booking_observation_ref: this.observationRef,
          booking_observation_title: this.observationTitle,
          booking_observation_type: this.theObservationType
        }
        this.$refs.form.reset()
        this.$emit('on-add-observation', item)
        this.theObservationType = '1'
        this.observationTitle = ''
      }
    }
  }
</script>

<style lang="sass">
.types
  margin: 0 auto
  text-align: center
  display: table

.headlines
  font-size: 18px !important
  font-weight: 500
  letter-spacing: normal !important
  font-family: 'Roboto', sans-serif
  padding: 34px

.card-texts
  padding: 34px
  margin-top: -38px
  width: 100%

.card-date
  margin-top: -6px
  width: 100%
  font-weight: 100
  padding-left: 34px
  font-size: 13px
  color: #49585f
</style>


// WEBPACK FOOTER //
// src/components/vuetify-observation-aggregator.vue